<template>
  <div class="warp">
    <navBox :page="'Introduction'"></navBox>
    
    <div class="">

      <Secondary :bgImage="bgImage" :Cntitle="Cntitle" :Entitle="Entitle">
          <template>
            <div  class="custom-layout">

                <div class="paragraph text-indent">
                  「约剑」——国内专注击剑运动的智能赛事平台，以全场景数字化赋能击剑赛事生态。
                </div>

                <div class="paragraph text-indent">
                  我们通过智能编排系统、AI智能裁判辅助及云端协同管理三大核心技术，彻底破解传统赛事中办赛资源错配、开赛流程繁琐、参赛体验割裂等痛点，实现「筹办-执行-参与」全流程数字化闭环。平台现已同步上线微信小程序与双端APP，为击剑爱好者、赛事方及裁判团队提供无缝衔接的一站式解决方案，让击剑赛事管理更高效、更智能！
                </div>

                <div class="paragraph">
                  <div>智能报名，简化至极的流程</div>
                  <div>
                    “约剑”采用智能化技术，以击剑赛事为中心的报名系统。简化报名流程，减少时间成本，提供参赛者与主办方的双向对接。
                  </div>
                </div>

                <div class="paragraph">
                  <div>名单自动导入，一键分组，一键出表</div>
                  <div>
                    “约剑”提供智能辅助与精准数据分析，简化赛事安排。通过数据分析，对参赛人员编排，淘汰表、分组表点击即见。
                  </div>
                </div>

                <div class="paragraph">
                  <div>小程序同步赛事进程</div>
                  <div>
                    约剑平台通过小程序进行赛事的实时更新和个性化推送。让参赛者随时随地掌握赛事最新动态，使主办方的赛事管理更为高效、智能。
                  </div>
                </div>

                <div class="paragraph">
                  <div>一键退费，高效便捷</div>
                  <div>
                    简化退款流程，显著提升办赛效率，降低操作失误。
                  </div>
                </div>

                <div class="paragraph">
                  <div>展示与宣传</div>
                  <div>
                    平台的俱乐部页面提供了场馆信息，特色课程等展示功能，同时约剑自媒体亦可助力于击剑爱好者的全覆盖宣传。
                  </div>
                </div>

            </div>
        </template>
      </Secondary>

    </div>
  </div>
</template>

<script>
import NavBox from '@/components/navBox.vue';
import Secondary from '../components/secondary.vue';
export default {
  name: 'yj_introduction',
  components:{ Secondary, NavBox },
  data(){
    return{
      Entitle: "INTRODUCTION",
      Cntitle: "约剑简介",
      bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250313/194267d2870edef99.jpg",
    }
  },

  
  methods:{
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度


.warp {
  margin: 0 auto;
  width: 100vw;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
  }
}

.custom-layout{
  font-size: 1.85em;
  letter-spacing: 0.03em;

  .text-indent{
    text-indent: 2em;
  }

  .paragraph{
    padding-bottom: 3em;
    line-height: 1.8em;
  }
}
</style>
